import React, { Component } from 'react';
import styled from 'styled-components';
import {AllPatients} from "./AllPatients";
import {RecentMissed} from "./RecentMissed";
import {withRouter} from 'react-router-dom';
import CheckLoginStatus from "../../conditions/CheckLoginStatus";
import DashboardLayout from "../../layouts/DashboardLayout";

// Container to center the content and add padding
// Use full width and reduce side padding
const PageContainer = styled.div`
  width: 100%;
  max-width: 1800px;   /* Increase max width to reduce white space on large screens */
  margin: 0 auto;      /* Center the container */
  padding: 0 20px;     /* Reduce side padding for more usable space */
  box-sizing: border-box;
`;

// Adjust HeaderContainer to center items
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

// Tabs container remains similar but will stretch to full width
const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #ccc;
  width: 100%;
  justify-content: center;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

// Button for each tab remains unchanged
const TabButton = styled.button`
  padding: 10px 20px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  outline: none;
  font-size: 16px;
  font-weight: ${(props) => (props.active ? 'bold' : 'normal')};
  border-bottom: ${(props) =>
  props.active ? '3px solid #007bff' : '3px solid transparent'};
  color: ${(props) => (props.active ? '#007bff' : '#000')};

  @media (max-width: 600px) {
    padding: 10px;
    border-left: ${(props) =>
  props.active ? '3px solid #007bff' : '3px solid transparent'};
    border-bottom: none;
    text-align: left;
  }

  &:hover {
    color: #007bff;
  }
`;

// Content area for the selected tab
const TabContent = styled.div`
  padding: 20px;
  width: 100%;

  @media (max-width: 600px) {
    padding: 15px;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 400px;
  position: relative;
  margin-top: 10px;
`;

export const SearchInput = styled.input`
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  flex: 1;
  max-width: 300px;
`;

export const SearchButton = styled.button`
  padding: 8px 12px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #0056b3;
  }
`;

// Container for the search and filters
export const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const SelectContainer = styled.div`
    flex: 1;
    max-width: 250px;  /* Increase width for wider dropdowns */
    margin-left: 10px;
    margin-right: 10px;
    width: 150px;
    &:first-child {
        max-width: 100px; /* Specific width for the first dropdown */
    }

    @media (max-width: 768px) {
        max-width: 100%;
        margin-left: 0;
        margin-bottom: 10px;  /* Add margin to separate stacked dropdowns */
    }
`;
export const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold', // Make the header text bold
      fontSize: '15px', // Increase the font size for more emphasis
      backgroundColor: '#f4f4f4', // Light gray background color to distinguish header
      color: '#333', // Darker text color for contrast
      textTransform: 'uppercase', // Optional: make header text uppercase for more emphasis
    },
  },
}
class AdherenceDashboard extends Component {
  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(this.props.location.search);
    const activeTab = urlParams.get('tab') || 'allPatients';

    this.state = {activeTab};
  }

  setActiveTab = (tab) => {
    this.props.history.push(`?tab=${tab}`);
    this.setState({ activeTab: tab });
  };

  render() {
    const { activeTab } = this.state;

    return (
      <CheckLoginStatus loggedOutRedirect='/'>
        <DashboardLayout title="Adherence Dashboard" noPad>
          <PageContainer>
            <HeaderContainer>
              <TabsContainer>
                <TabButton
                  active={activeTab === 'allPatients'}
                  onClick={() => this.setActiveTab('allPatients')}
                >
                  All Patients
                </TabButton>
                <TabButton
                  active={activeTab === 'needsDevice'}
                  onClick={() => this.setActiveTab('needsDevice')}
                >
                  Needs Device
                </TabButton>
                <TabButton
                  active={activeTab === 'notActivated'}
                  onClick={() => this.setActiveTab('notActivated')}
                >
                  Not Activated
                </TabButton>
                <TabButton
                  active={activeTab === 'recentMissed'}
                  onClick={() => this.setActiveTab('recentMissed')}
                >
                  Recent Missed
                </TabButton>

              </TabsContainer>
              <SearchContainer>
                <SearchInput
                  type="text"
                  placeholder="Patient, device, or phone #"
                />
                <SearchButton>
                  <span className="fas fa-search" />
                </SearchButton>
              </SearchContainer>
            </HeaderContainer>

            <TabContent>
              {activeTab === 'allPatients' && <AllPatients />}
              {activeTab === 'needsDevice' && <div>Needs Device content goes here</div>}
              {activeTab === 'notActivated' && <div>Not Activated content goes here</div>}
              {activeTab === 'recentMissed' && <RecentMissed />}
            </TabContent>
          </PageContainer>
        </DashboardLayout>
      </CheckLoginStatus>
    );
  }
}

export default withRouter(AdherenceDashboard);


// WEBPACK FOOTER //
// ./src/pages/AdherenceDashboard/index.js